import { useMemo } from "react";

import Breadcrumbs from "@/components/breadcrumbs";
import DownloadApp from "@/components/download-app";
import Header from "@/components/header-v2";
import { Accordion } from "@/components/ui/accordion";
import { useIsBreakPoint } from "@/hooks/use-is-break-point";

import Region, { type RegionType } from "./region";

export type { CityType, RegionType } from "./region";

export interface CitiesProps {
  regions: RegionType[];
}

export function CityAccordion({ regions }: { regions: RegionType[] }) {
  const isDesktop = useIsBreakPoint("md");

  const props = useMemo(
    () =>
      isDesktop
        ? { value: regions.map(({ name }) => name) }
        : { defaultValue: [regions[0].name] },
    [isDesktop, regions]
  );

  return (
    <Accordion className="mt-[50px] md:mt-15" type="multiple" {...props}>
      {regions.map((region) => (
        <Region key={region.name} region={region} />
      ))}
    </Accordion>
  );
}

export default function Cities({ regions }: CitiesProps) {
  return (
    <>
      <Header variant="simplified" />
      <Breadcrumbs
        breadcrumbs={[{ name: "All cities", url: "/cities" }]}
        className="pt-5"
        title="**All** cities"
      />
      <div className="container mt-[15px] md:mt-10">
        <p className="text-center text-14/[1.7em] text-pale-lavender md:text-20/[1.5em]">
          Morty is in more than 1,000 cities including many not listed below
        </p>
        <CityAccordion regions={regions} />
        <DownloadApp className="my-20 pt-[167px] md:my-35 md:py-[183px]" />
      </div>
    </>
  );
}
